import { AppContext } from "@lightspeed-invoicing/core-client/frontend/index"
import { integrationKeyVend } from "../../integration/IntegrationConstants"
import { HttpError, isError } from "../helpers/Error"
import HttpClient from "../helpers/HttpClient"
import { INTEGRATION_KEY } from "./Constants"
import { ExternalPaymentMethodTypes } from "./ExternalPaymentMethodType"
import { ExternalSubscription } from "./ExternalSubscription"
import IntegrationConfiguration, { IntegrationConfigurationDto } from "./IntegrationConfiguration"
import { ExternalAccountStatusDto } from "./dtos"
import { FormOptionsDto } from "./form-options/types"

class IntegrationConfigurationService {
    static httpClient = new HttpClient<IntegrationConfiguration, IntegrationConfigurationDto>(IntegrationConfiguration)

    static async retrieveExternalPaymentTypes(
        integrationConfigurationID: string
    ): Promise<ExternalPaymentMethodTypes | HttpError> {
        const res = await AppContext.getApiClient().get(`/integrations/${integrationConfigurationID}/payment-method-types`)
        if (isError(res)) {
            return res as HttpError
        }
        return res as ExternalPaymentMethodTypes
    }

    static async ValidateAccountStatus(integrationKey: string): Promise<ExternalAccountStatusDto | HttpError> {
        const res = await AppContext.getApiClient().get(`/integrations/${integrationKey}/validate-account-status`)
        if (isError(res)) {
            return res as HttpError
        }
        return res as ExternalAccountStatusDto
    }

    static async validateExternalSubscription(integrationKey: string, body: object): Promise<ExternalSubscription> {
        const res = await AppContext.getApiClient().post(`/${integrationKey}/validate-external-subscription`, body)
        return res as ExternalSubscription
    }

    static async validateExternalFeature(integrationKey: string, externalFeatureKey: string, body: object) {
        return await AppContext.getApiClient().post(`/${integrationKey}/validate-external-feature/${externalFeatureKey}`, body)
    }

    static async isActiveNonPremiumVendAccount(): Promise<boolean> {
        const res = await IntegrationConfigurationService.ValidateAccountStatus(integrationKeyVend)
        if (isError(res)) {
            return false
        }
        if (!res.isValid) {
            return false
        }
        if (res.status === "trialing") {
            return false
        }
        const r = await IntegrationConfigurationService.validateExternalFeature(
            integrationKeyVend,
            "trigger-create-workflow-objects",
            { "accountId": AppContext.getAccount().id }
        )
        return r.error && r.error.code === 401
    }

    static async getConfigurationFormOptions(integrationKey: INTEGRATION_KEY): Promise<FormOptionsDto | HttpError> {
        const res = await AppContext.getApiClient().get("/" + integrationKey + "/form-options")
        if (isError(res)) {
            return res as HttpError
        }
        return res as FormOptionsDto
    }

}

export default IntegrationConfigurationService


// WEBPACK FOOTER //
// ./src/state/integration/IntegrationConfigurationService.ts